import PropTypes from 'prop-types';
import React, { Component } from 'react';
import i18next from "../../i18n";
import { ActionsPanel } from '../forms/ActionsPanel';
import { dispatcherActionTypes, globalEventDispatcher } from '../helpers/GlobalEventDispatcher';
import { Pagination } from '../Pagination';
import { ColumnFilter } from './ColumnFilter';
import { TableRow } from './TableRow';
import { History } from '../helpers/History';
import { onFormInputKeyDown } from '../helpers/HelperFunctions';

export const TableColumnType = {
    Default: "default",
    Bool: "bool",
    String: "string",
    ColoredString: "coloredString",
    Double: "double",
    Date: "date",
    Status: "status",
    Phone: "phone",
    Email: "email",
    DateTime: "datetime",
    Enum: "enum",
    Button: "button",
    Comment: "comment",
    DocLink: "docLink",
    Reorder: "reorder"
}
export async function saveColumnSettings(url, columnSettings, handleSuccess) {
    await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(columnSettings)
    })
        .then((response) => {
            if (!response.ok) require('../ModalDialogsTemplates').unknownErrorMessageDialog();
            else if (handleSuccess) {
                handleSuccess();
            }
        });
}
export class Table extends Component {
    static propTypes = {
        name: PropTypes.string,
        columns: PropTypes.array,
        rows: PropTypes.array,
        actions: PropTypes.array,
        showActionsPanel: PropTypes.bool
    };
    constructor(props) {
        super(props);
        this.state = {
            sortBy: props.sortBy,
            isDesk: props.isDesk,
            checkedList: [],
            allChecked: false,
            actions: [],
            showActionsPanel: false
        }
        this.sort = this.sort.bind(this);
        this.handlerCheck = this.handlerCheck.bind(this);
        this.handlerCheckAll = this.handlerCheckAll.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleChangePageSize = this.handleChangePageSize.bind(this);
        this.handlerUncheckAll = this.handlerUncheckAll.bind(this);
        this.actionHandlerCallback = this.actionHandlerCallback.bind(this);
        this.globalEventListerner = this.globalEventListerner.bind(this);
        globalEventDispatcher.subscribe(this.globalEventListerner);
    }
    componentWillUnmount() {
        globalEventDispatcher.unsubscribe(this.globalEventListerner);
    }
    globalEventListerner(actionType, params) {
        if (actionType === dispatcherActionTypes.onUnselectTableAllRows) {
            this.handlerUncheckAll();
        }
        if (actionType === dispatcherActionTypes.onRowSelected) {
            if (params && this.props.name && params.tableName !== this.props.name)
                this.handlerUncheckAll();
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.sortBy !== prevProps.sortBy || this.props.isDesk !== prevProps.isDesk || this.props.checked !== prevProps.checked || prevProps.items !== this.props.items) {
            let checked = this.props.checked ? this.props.checked : [];
            let checkedList = this.state.checkedList;
            if (prevProps.items !== this.props.items) {
                if (!this.props.items || this.props.items.length === 0)
                    checkedList = [];
                else
                    checkedList = checkedList.filter(checkedItem => this.props.items.some(it => it.columns["Id"] === checkedItem));
            }
            let actions = this.getActions(checkedList, this.props.items);
            this.setState({ sortBy: this.props.sortBy, isDesk: this.props.isDesk, checked: checked, actions: actions, checkedList: checkedList });
        }
    }
    getActions(checkedList = null, items = null) {
        try {
            if (!items)
                items = this.props.items;
            let result = [];
            if (checkedList.length <= 0)
                return [];
            if (checkedList.length === 1) {
                result = items.find(it => it.columns["Id"] === checkedList[0]).actions.slice(0);
            }
            else {
                let checkedItems = items.filter(it => checkedList.includes(it.columns["Id"]));
                for (let i = 0; i < checkedList.length; i++) {
                    try {
                        let item = items.find(it => it.columns["Id"] === checkedList[i]);
                        if (item && item.actions) {
                            let actions = item.actions.filter(it => it.isMultiaction && (it.maxActionCount <= 0 || checkedList.length <= it.maxActionCount));
                            for (let j = 0; j < actions.length; j++) {
                                let action = result.find(it => it.type === actions[j].type);
                                if (!action) {
                                    let hasNowAction = checkedItems.find(it => !it.actions.find(act => act.type === actions[j].type));
                                    if (!hasNowAction)
                                        result.push(actions[j]);
                                }
                            }
                        }
                    }
                    catch { }
                }
            }
            if (this.props.actionsForAll) {
                for (let i = 0; i < this.props.actionsForAll.length; i++) {
                    if (!((!this.props.actionsForAll[i]?.isMultiaction) && checkedList.length > 1))
                        result.push(this.props.actionsForAll[i]);
                }
            }
            return result;
        }
        catch {
            return [];
        }
    }
    handlerCheckAll(event) {
        if (event.target.checked) {
            let checkedList = [];
            let items = this.props.items;
            for (var i = 0; i < items.length; i++) {
                checkedList.push(items[i].columns.Id);
            }
            this.setState({ allChecked: true, checkedList: checkedList, showActionsPanel: true, actions: this.getActions(checkedList) });
            if (this.props.onCheckChangeHandler)
                this.props.onCheckChangeHandler(checkedList);
            globalEventDispatcher.dispatch(dispatcherActionTypes.onRowSelected, { tableName: this.props.name });
        }
        else {
            this.setState({ allChecked: false, checkedList: [], showActionsPanel: false, actions: [] });
            if (this.props.onCheckChangeHandler)
                this.props.onCheckChangeHandler([]);
        }
    }
    handlerCheck(event) {
        let isChecked = event.target.checked;
        let { checkedList } = this.state;
        let isAll = false;
        let showActionsPanel = true;
        let index = checkedList.indexOf(event.target.id);
        if (isChecked) {
            if (index < 0) {
                checkedList.push(event.target.id);
                if (this.props.items && checkedList.length === this.props.items.length)
                    isAll = true;
            }
            else {
                isAll = this.state.allChecked;
            }
            globalEventDispatcher.dispatch(dispatcherActionTypes.onRowSelected, { tableName: this.props.name });
        }
        else {
            if (index >= 0)
                checkedList.splice(index, 1);
            if (checkedList.length <= 0)
                showActionsPanel = false;
        }
        this.setState(
            {
                checkedList: checkedList,
                allChecked: isAll,
                showActionsPanel: showActionsPanel,
                actions: showActionsPanel ? this.getActions(checkedList) : []
            }
        );
        if (this.props.onCheckChangeHandler)
            this.props.onCheckChangeHandler(checkedList);
    }
    sort(name) {
        let { sortBy, isDesk } = this.state;
        if (name === sortBy)
            isDesk = !isDesk;
        else
            isDesk = false;
        this.setState({ sortBy: name, isDesk: isDesk });
        if (this.props.handleSortChange)
            this.props.handleSortChange(name, isDesk);
    }
    handlePageChange(page) {
        this.setState({ allChecked: false, checkedList: [], showActionsPanel: false, actions: [] });
        if (this.props.handlePageChange)
            this.props.handlePageChange(page);
        if (this.props.onCheckChangeHandler)
            this.props.onCheckChangeHandler([]);
    }
    handleChangePageSize(pageSize) {
        this.setState({ allChecked: false, checkedList: [], showActionsPanel: false, actions: [] });
        if (this.props.handleChangePageSize)
            this.props.handleChangePageSize(pageSize);
        if (this.props.onCheckChangeHandler)
            this.props.onCheckChangeHandler([]);
    }
    handlerUncheckAll() {
        this.setState({ allChecked: false, checkedList: [], showActionsPanel: false, actions: [] });
        if (this.props.onCheckChangeHandler)
            this.props.onCheckChangeHandler([]);
    }
    actionHandlerCallback(type) {
        if (this.props.actionHandlerCallback) {
            this.props.actionHandlerCallback(type, this.state.checkedList);
        }
    }
    render() {
        let { name, columns, items, allCount, showPagination, page, pageSize, allowedEnumValues, pageCount, showMoreLink, actionHandlerCallback, disableSelection } = this.props;
        const { sortBy, isDesk, allChecked, checkedList, actions, showActionsPanel } = this.state;
        let index = 0;
        if (!page)
            page = 1;
        if (!pageSize)
            pageSize = 10;
        if (!pageCount)
            pageCount = 1;
        if (!allowedEnumValues)
            allowedEnumValues = {};
        return (
            <div className="table-block">
                <div className="table-response">
                    <table className={disableSelection ? "selection-disabled" : ""}>
                        <thead>
                            <tr>
                                {!disableSelection &&
                                    <th>
                                        <input id={name + "s1"} type="checkbox" onKeyDown={onFormInputKeyDown} onChange={this.handlerCheckAll} checked={!!allChecked} />
                                        <label htmlFor={name + "s1"}></label>
                                    </th>
                                }
                                {columns.map(column =>
                                    <th key={column.id} className={column.canSort ? "sorting-col" : ""} name={column.name} style={{ display: (column.hidden === true ? "none" : "table-cell") }}>
                                        {sortBy === column.name && (!isDesk ?
                                            //<svg onClick={column.canSort ? () => this.sort(column.name) : () => { }} className="order" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            //    <path d="M0 8L1.41 9.41L7 3.83V16H9V3.83L14.58 9.42L16 8L8 0L0 8Z" fill="black" />
                                            //</svg>
                                            
                                            <svg onClick={column.canSort ? () => this.sort(column.name) : () => { }} className="order" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16ZM8.49995 2.58569L9.20706 3.2928L13.2071 7.2928L11.7928 8.70701L9.49995 6.41412V12.9999H7.49995V6.41412L5.20706 8.70701L3.79285 7.2928L7.79285 3.2928L8.49995 2.58569Z" fill="black" fillOpacity="0.2"/>
                                            </svg>
                                            :
                                            //<svg onClick={column.canSort ? () => this.sort(column.name) : () => { }} className="order" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            //    <path d="M16 8L14.59 6.59L9 12.17V0H7V12.17L1.42 6.58L0 8L8 16L16 8Z" fill="black" />
                                            //</svg>

                                            <svg onClick={column.canSort ? () => this.sort(column.name) : () => { }} className="order active" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16ZM8.49995 2.58569L9.20706 3.2928L13.2071 7.2928L11.7928 8.70701L9.49995 6.41412V12.9999H7.49995V6.41412L5.20706 8.70701L3.79285 7.2928L7.79285 3.2928L8.49995 2.58569Z" fill="black" fillOpacity="0.2" />
                                            </svg>

                                            )   
                                        }
                                        <span onClick={column.canSort ? () => this.sort(column.name) : () => { }}>
                                            {column.headerName}
                                        </span>
                                        {column.showFilterInColumn !== null && column.showFilterInColumn && column.enums && column.enums.length > 0 &&
                                            <ColumnFilter allowedValues={allowedEnumValues[column.name]} onColumnFilter={this.props.onColumnFilter} column={column} />
                                        }
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item) => (
                                <TableRow key={index++} disableSelection={disableSelection} handlerCheck={this.handlerCheck} allowDoubleClickAction={this.props.allowDoubleClickAction} handlerAction={actionHandlerCallback} cols={columns} checked={item && item.columns && item.columns.Id && checkedList.includes(item.columns.Id)} item={item}></TableRow >
                            ))}
                        </tbody>
                    </table>
                </div>
                {showPagination &&
                    <Pagination
                        page={page}
                        pageSize={pageSize}
                        pageCount={pageCount}
                        allCount={allCount}
                        handlePageChange={this.handlePageChange}
                        handleChangePageSize={this.handleChangePageSize} />
                }
                {showMoreLink &&
                    <a className="more" onClick={() => History.push("/documents/docs")}>
                        <span>{i18next.t("allDocuments")}</span>
                        <span className="collapsed-menu-icone"></span>
                    </a>
                }
                {showActionsPanel && actions && actions.length > 0 &&
                    <ActionsPanel actions={actions} handlerUncheckAll={this.handlerUncheckAll} actionHandlerCallback={this.actionHandlerCallback} checkedCount={checkedList.length} />
                }
            </div>
        );
    }
}
export function getEnumsTitle(collumnsSettings, collumnName, value) {
    return collumnsSettings?.find((item) => item?.name === collumnName)?.enums?.find((item) => item?.value === value)?.title;
}
